// ChangePasswordView.jsx
import { useState } from 'react';
import styled from 'styled-components';
import { Input } from '../../../components/ui';
import { useDispatch, useSelector } from 'react-redux';
import { setCustomer } from '../../../api/services/customerService';
import { setUserInfo } from '../../../redux/userInfo';

const FormContainer = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1.5rem;
  width: 100%;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const Title = styled.h1`
  width: 100%;
  font-size: 24px;
  margin-bottom: 1.5rem;
  text-align: center;
`;

const InputGroup = styled.div`
  width: 80%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const InputLabel = styled.label`
  font-size: 14px;
  color: #444;
`;

const InputContainer = styled.div`
  width: 100%;
  border: 1px solid #ccc;
  margin-bottom: 20px;
`;

const SubmitButton = styled.button`
  width: 80%;
  padding: 12px;
  background-color: ${(props) => props.theme.colors.primaryBlue};
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  margin-top: 1rem;
  transition: background-color 0.2s;

  &:hover {
    opacity: 0.8;
  }
`;

const CustomerInfoView = () => {
  const dispatch = useDispatch();
  const userInfo = useSelector((state) => state.userInfo);

  const [customerInfo, setCustomerInfo] = useState(userInfo);

  const handleSave = async () => {
    const result = await setCustomer(userInfo.idCustomer, customerInfo);
    if (result.is_success) {
      dispatch(
        setUserInfo({
          firstname: customerInfo.firstname,
          lastname: customerInfo.lastname,
          email: customerInfo.email,
          companyNm: customerInfo.companyNm,
          tell: customerInfo.tell,
          cellPhone: customerInfo.cellPhone,
          fax: customerInfo.fax,
        }),
      );
    }
  };

  return (
    <FormContainer>
      <Title>Customer info</Title>

      <InputGroup>
        <InputLabel>User ID:</InputLabel>
        <InputContainer>
          <Input disabled={true} type='text' value={customerInfo.userId} />
        </InputContainer>
      </InputGroup>

      <InputGroup>
        <InputLabel>Business Name:</InputLabel>
        <InputContainer>
          <Input
            type='text'
            value={customerInfo.companyNm}
            onChange={(e) => {
              setCustomerInfo({ ...customerInfo, companyNm: e });
            }}
          />
        </InputContainer>
      </InputGroup>

      <InputGroup>
        <InputLabel>First name:</InputLabel>
        <InputContainer>
          <Input
            type='text'
            value={customerInfo.firstname}
            onChange={(e) => {
              setCustomerInfo({ ...customerInfo, firstname: e });
            }}
          />
        </InputContainer>
      </InputGroup>

      <InputGroup>
        <InputLabel>Last name:</InputLabel>
        <InputContainer>
          <Input
            type='text'
            value={customerInfo.lastname}
            onChange={(e) => {
              setCustomerInfo({ ...customerInfo, lastname: e });
            }}
          />
        </InputContainer>
      </InputGroup>

      <InputGroup>
        <InputLabel>Email:</InputLabel>
        <InputContainer>
          <Input
            type='text'
            value={customerInfo.email}
            onChange={(e) => {
              setCustomerInfo({ ...customerInfo, email: e });
            }}
          />
        </InputContainer>
      </InputGroup>

      <InputGroup>
        <InputLabel>Telephone:</InputLabel>
        <InputContainer>
          <Input
            type='text'
            value={customerInfo.tel}
            onChange={(e) => {
              setCustomerInfo({ ...customerInfo, tel: e });
            }}
          />
        </InputContainer>
      </InputGroup>
      <InputGroup>
        <InputLabel>Fax:</InputLabel>
        <InputContainer>
          <Input
            type='text'
            value={customerInfo.fax}
            onChange={(e) => {
              setCustomerInfo({ ...customerInfo, fax: e });
            }}
          />
        </InputContainer>
      </InputGroup>
      <InputGroup>
        <InputLabel>Mobile Phone:</InputLabel>
        <InputContainer>
          <Input
            type='text'
            value={customerInfo.cellPhone}
            onChange={(e) => {
              setCustomerInfo({ ...customerInfo, cellPhone: e });
            }}
          />
        </InputContainer>
      </InputGroup>

      <SubmitButton onClick={handleSave}>SAVE</SubmitButton>
    </FormContainer>
  );
};

export default CustomerInfoView;
